module.exports = __webpack_public_path__ + "img/丽江1_1.75b9c8f7.jpg";